@use "../../../../shared/scss" as *;

phn-nd-dealer-card {
  --padding: #{$pds-spacing-static-small};
  padding-block: 1.5rem;
  padding-inline: 1.5rem;
  background-color: $pds-theme-light-background-surface;
  margin-block: $pds-spacing-static-medium;
  margin-inline: 0;
  border-radius: $pds-spacing-static-small;
  display: grid;
  gap: calc($pds-spacing-static-medium - var(--padding));
  font-family: "Porsche Next";
  line-height: 1.5;
  overflow-wrap: anywhere;

  @include pds-media-query-min("s") {
    background-color: $pds-theme-light-background-base;
  }

  & *:focus-visible {
    @include design-system__focus();
  }

  &:has(.flyout-back) {
    padding-inline: $pds-spacing-static-small;

    @include pds-media-query-max("s") {
      padding-inline: p-px-to-rem(27px);
    }

    & .desktop-address {
      inline-size: auto !important;

      & phn-p-tag {
        display: initial;
      }
    }
  }

  & a {
    text-decoration: none;
    color: inherit;
  }

  & .hover-element {
    padding-block: calc(var(--padding) / 2);
    padding-inline: var(--padding);
    transition: background-color $pds-motion-duration-short;
    border-radius: $pds-spacing-static-x-small;
    inline-size: fit-content;
  }

  @media (hover: hover) and (pointer: fine) {
    & .hover-element:hover {
      background-color: $pds-theme-light-state-hover;
    }
  }

  & .dealer-name {
    margin-block: 0;
    margin-inline: 0;
    @include pds-heading-medium;
  }

  & .desktop-address {
    display: flex;
    gap: var(--padding);
    inline-size: auto;
    padding-inline-end: 0;

    & .route-icon {
      display: none;
    }
    & .pin-icon {
      display: block;
    }
    & a {
      display: grid;
    }
    & phn-p-tag {
      align-self: center;
      margin-inline-start: auto;
    }
  }

  & .dealer-homepage,
  & .dealer-phone,
  & .dealer-mail,
  & .dealer-opening-hours,
  & .dealer-finder,
  & .dealer-drive {
    display: flex;

    & a,
    & span {
      margin-inline-start: $pds-spacing-static-small;
    }
  }

  & .dealer-phone:dir(rtl) {
    & a {
      margin-inline-end: $pds-spacing-static-small;
    }
  }

  & .dealer-opening-hours {
    padding-block: var(--padding);
    padding-inline: var(--padding);

    & span {
      white-space: pre;
      text-wrap: auto;
    }
  }

  & .dealer-more {
    margin-block-start: $pds-spacing-static-small;
    inline-size: 100%;

    & phn-p-icon {
      display: none;

      @include pds-media-query-min("s") {
        display: inline-block;
      }
    }
  }

  & .flyout-address,
  & .flyout-directions,
  & .flyout-headline {
    display: none;
  }

  &.router-dealer-card {
    background-color: $pds-theme-light-background-base;
    gap: 0;

    @include pds-text-medium;
    @include pds-media-query-min("s") {
      @include pds-text-small;
    }

    & > .hover-element,
    & > .dealer-opening-hours {
      margin-inline-start: (-$pds-spacing-static-small);
    }

    & .dealer-name {
      @include pds-heading-large;
      @include pds-media-query-min("s") {
        @include pds-heading-medium;
      }
    }

    & .desktop-address {
      inline-size: fit-content;
    }

    & .flyout-address {
      display: block;
      margin-block-start: $pds-spacing-static-small;
      margin-block-end: 1.5rem;
      color: $pds-theme-light-contrast-high;
    }

    & phn-p-tag,
    & .pin-icon,
    & .flyout-directions ~ * {
      display: none;
    }
    & .route-icon,
    & .flyout-directions,
    & .flyout-headline {
      display: block;
    }

    & .flyout-headline,
    & .flyout-back {
      margin-block-start: $pds-spacing-static-large;
    }

    & .flyout-headline {
      margin-block-end: $pds-spacing-static-small;
      font-weight: 600;
    }
  }
}
